import worksbg from "../assets/images/hero-bg.jpg";
import { Container, Row, Col, Table } from "react-bootstrap";
import { useState, useEffect, useRef } from 'react';


import emarah_logo from '../assets/images/our-works-logos/Emarah_Villas.png';
import DTLogo from '../assets/images/our-works-logos/DT-logo.png';
import kawatihi_logo from '../assets/images/our-works-logos/kawatihi_logo.png';
import mahira_logo from '../assets/images/our-works-logos/mahira_logo.png';
import advanced_grohair_logo from '../assets/images/our-works-logos/adgroadglo.png';
import filler_logo from '../assets/images/our-works-logos/filler.png';
import mahive_logo from '../assets/images/our-works-logos/mahive-logo.png';
import sathish_logo from '../assets/images/our-works-logos/sds-logo.svg';

import saturn from '../assets/images/saturn.svg';
import dna from '../assets/images/dna.svg';

import rocketIcon from '../assets/images/rocket-icon.svg';
import moon from '../assets/images/moon.svg';

import sun from '../assets/images/sun.svg';
import atoms from '../assets/images/atoms.svg';

import atom from '../assets/images/atom.svg';
import rover from '../assets/images/rover.svg';

import gallaxy from '../assets/images/gallaxy.svg';
import fireball from '../assets/images/fireball.svg';

import map from '../assets/images/map.png';

const CaseStudy = () => {

    const [expandedSections, setExpandedSections] = useState([]);
    const sectionRefs = useRef([]);

    useEffect(() => {
        const handleObserve = (entries) => {
            setExpandedSections((prev) => {
                let updated = [...prev];
                entries.forEach((entry) => {
                    const sectionIdx = Number(entry.target.dataset.idx);
                    if (entry.isIntersecting) {
                        if (!updated.includes(sectionIdx)) updated.push(sectionIdx);
                    }
                });
                return updated;
            });
        };

        const observer = new window.IntersectionObserver(handleObserve, {
            threshold: 0.15,
            rootMargin: '0px 0px -50px 0px'
        });
        sectionRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });
        return () => observer.disconnect();
    }, []);

    return (
        <div>
            {/* Hero Section */}
            <div
                className="service-section-bg"
                style={{ backgroundImage: `url(${worksbg})` }}
            >
                <div className='service-overlay position-relative text-center'>
                    <h1 className='serive-page-title'>
                        Our Case <span className="outline-theme-text">Study</span>
                    </h1>
                </div>
            </div>


            <div className="position-relative">
                <img src={saturn} alt='floating-icons' className='floating-icons left' />
                <img src={rocketIcon} alt='floating-icons' className='floating-icons right bottom' />

                <Container className="pb-5 mb-5 mt-3" ref={el => sectionRefs.current[0] = el} data-idx={0}>
                    <Row>
                        <Col xs={12} lg={3} className="mx-auto">
                            <div className={`logo-circle ms-lg-auto bg-white ${expandedSections.includes(0) ? ' expanded' : ''}`}>
                                <img src={emarah_logo} alt="logo" className="case-study-logo" />
                            </div>
                        </Col>
                        <Col xs={12} lg={9} className={`case-study-wrapper${expandedSections.includes(0) ? ' expanded' : ''}`}>
                            <div className="case-study-card">
                                <h2 className="case-study-title">Emarah Villas</h2>
                                <p className="case-study-description">
                                    Emarah Villas, a premium real estate brand in Tamil Nadu,
                                    partnered with us to drive high-intent leads and boosts
                                    site visits for thi luxury villas through targeted Meta Ads
                                </p>

                                <h3 className="case-study-title">Goals</h3>

                                <ul>
                                    <li>Generated high-intent real estate leads</li>
                                    <li>Lower CPL without quality drop</li>
                                    <li>Support sales with better inquiries</li>
                                    <li>Stand Out in crowded market</li>
                                </ul>

                                <h3 className="case-study-title">Results</h3>

                                <ul>
                                    <li>422 leads at  Rs 200.70 CPL</li>
                                    <li>80% sales-validated lead quality</li>
                                    <li>2 villas sold, Rs 3.2 - 4 Cr</li>
                                    <li>Lowest CPL via city targeting</li>
                                </ul>

                                <p className="case-study-description">Through smart audience targeting, creative storytelling, and optimized lead
                                    workflows, Emrah’s campaign turned digital visibility into retal estate sales
                                    with high effciency and measurable ROI.
                                </p>


                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="position-relative">
                <img src={dna} alt='floating-icons' className='floating-icons left' />
                <img src={atom} alt='floating-icons' className='floating-icons right bottom' />

                <Container className="pb-5 mb-5" ref={el => sectionRefs.current[1] = el} data-idx={1}>
                    <Row>
                        <Col xs={{ span: 12, order: 'last' }} lg={{ span: 9, order: 'first' }} className={`case-study-wrapper${expandedSections.includes(1) ? ' expanded' : ''}`}>
                            <div className="case-study-card">
                                <h2 className="case-study-title">Design Triangle</h2>
                                <p className="case-study-description">
                                    Design Triangle, is a chennai-based interior design firm
                                    offering fully customizable interiors with end-to-end
                                    execution, powerd by their in-house furniture factory.
                                    Known for delivering quality and creativity, they transform
                                    spaces across India with precision and style.
                                </p>

                                <h3 className="case-study-title">Challenges</h3>

                                <ul>
                                    <li>Low online brand visibility</li>
                                    <li>Poor lead quality overall</li>
                                    <li>Undervalued in-huse capabilities</li>
                                    <li>Weak national brand presence</li>
                                </ul>

                                <h3 className="case-study-title">Results</h3>

                                <ul>
                                    <li>3x increase in quality leads</li>
                                    <li>35% drop in lead cost</li>
                                    <li>Viral reach via instagram reels</li>
                                    <li>Inquiries from 10+ cities</li>
                                </ul>

                                <p className="case-study-description">The brand is now positioned as a go-to choice for luxury, custom interiors
                                    across India.

                                </p>


                            </div>
                        </Col>
                        <Col lg={{ span: 3, order: 'last' }} className="mx-auto" xs={{ span: 12, order: 'first' }} >
                            <div className={`logo-circle me-auto${expandedSections.includes(1) ? ' expanded' : ''}`}>
                                <img src={DTLogo} alt="logo" className="case-study-logo" style={{width: "300px"}} />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>


            <div className="position-relative">
                <img src={rover} alt='floating-icons' className='floating-icons left' />
                <img src={atoms} alt='floating-icons' className='floating-icons right bottom rotate' />

                <Container className="pb-5 mb-5 mt-3" ref={el => sectionRefs.current[2] = el} data-idx={2}>
                    <Row>
                        <Col xs={12} lg={3} className="mx-auto">
                            <div className={`logo-circle ms-lg-auto${expandedSections.includes(2) ? ' expanded' : ''}`}>
                                <img src={kawatihi_logo} alt="logo" className="case-study-logo" />
                            </div>
                        </Col>
                        <Col xs={12} lg={9} className={`case-study-wrapper${expandedSections.includes(2) ? ' expanded' : ''}`}>
                            <div className="case-study-card">
                                <h2 className="case-study-title">AL-Kawatihi Fish Company</h2>
                                <p className="case-study-description">
                                    AL-KAWATIHI FISH COMPANY, is a premium seafood brand
                                    in Kuwait, delivering fresh, high-quality fish from sea to
                                    table, To boost visibility and daily orders, the brand
                                    partnered with our agency for Instagram and Google Ads
                                    campaigns.
                                </p>

                                <h3 className="case-study-title">Challenges</h3>

                                <ul>
                                    <li>Inconsistent daily sales</li>
                                    <li>Low overall brand recall</li>
                                    <li>Poor lead qualification</li>
                                    <li>High spend, low returns</li>
                                </ul>

                                <h3 className="case-study-title">Results</h3>




                                <ul>
                                    <li>65% rise in qualified leads</li>
                                    <li>20k+ reach via reels</li>
                                    <li>4.8% CTR on Meta</li>
                                    <li>Increased festive/weekend orders</li>
                                </ul>

                                <p className="case-study-description">AL-Kawatihi in now a top-of-mind seafood choice for households across
                                    Kuwait.
                                </p>


                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>


            <div className="position-relative">
                <img src={sun} alt='floating-icons' className='floating-icons left' />
                <img src={gallaxy} alt='floating-icons' className='floating-icons right bottom' />

                <Container className="pb-5 mb-5" ref={el => sectionRefs.current[3] = el} data-idx={3}>
                    <Row>
                        <Col xs={{ span: 12, order: 'last' }} lg={{ span: 9, order: 'first' }} className={`case-study-wrapper${expandedSections.includes(3) ? ' expanded' : ''}`}>
                            <div className="case-study-card">
                                <h2 className="case-study-title">Mahira Mohsin</h2>
                                <p className="case-study-description">
                                    MAHIRA MOHSIN, is a bespoke henna brand known for
                                    elegant bridal and festive designs. They partnered with us
                                    to grow her Instagram presence and turn artistic content
                                    into business traction.
                                </p>

                                <h3 className="case-study-title">Challenges</h3>
                                <ul>
                                    <li>Slow follower growth</li>
                                    <li>Low content engagement</li>
                                    <li>Poor audience targeting</li>
                                    <li>Lacked unique brand voice</li>
                                </ul>

                                <h3 className="case-study-title">Results</h3>

                                <ul>
                                    <li>Reels boosted engagement</li>
                                    <li>Seasonal content increased reach</li>
                                    <li>Client stories built trust</li>
                                    <li>Instagram became lead generator</li>
                                </ul>

                                <p className="case-study-description">Mahira Mohsin’s Instagram transformed into a high
                                    engagement platform, consistently attracting brides,
                                    influencers, and henna enthusiasts the region.
                                </p>


                            </div>
                        </Col>
                        <Col lg={{ span: 3, order: 'last' }} className="mx-auto" xs={{ span: 12, order: 'first' }}>
                            <div className={`logo-circle me-auto${expandedSections.includes(3) ? ' expanded' : ''}`}>
                                <img src={mahira_logo} alt="logo" className="case-study-logo" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="position-relative">
                <img src={fireball} alt='floating-icons' className='floating-icons left' />
                <img src={rocketIcon} alt='floating-icons' className='floating-icons right bottom' />


                <Container className="pb-5 mb-5 mt-3" ref={el => sectionRefs.current[4] = el} data-idx={4}>
                    <Row>
                        <Col xs={12} lg={3} className="mx-auto">
                            <div className={`logo-circle ms-lg-auto bg-white ${expandedSections.includes(4) ? ' expanded' : ''}`}>
                                <img src={advanced_grohair_logo} alt="logo" className="case-study-logo" />
                            </div>
                        </Col>
                        <Col xs={12} lg={9} className={`case-study-wrapper${expandedSections.includes(4) ? ' expanded' : ''}`}>
                            <div className="case-study-card">
                                <h2 className="case-study-title">advanced grohair & gloskin</h2>
                                <p className="case-study-description">
                                    ADVANCED GROHAIR & GLOSKIN, with 100+ branches
                                    across India, specialize in hair restoration and skin
                                    treatments. They partnered with us to boost digital
                                    visibility and generate quality leads vis Meta and Google
                                    ads.
                                </p>

                                <h3 className="case-study-title">Challenges</h3>

                                <ul>
                                    <li>Inconsistent daily sales</li>
                                    <li>Low overall brand recall</li>
                                    <li>High consultation drop-offs</li>
                                    <li>Low ad campaign ROI</li>
                                </ul>

                                <h3 className="case-study-title">Results</h3>

                                <ul>
                                    <li>ZIP-level lead targeting</li>
                                    <li>Trust-building doctor content</li>
                                    <li>CRM-based calback conversions</li>
                                    <li>Strong Tier 1 & 2 presence</li>
                                </ul>

                                <p className="case-study-description">Advanced Gro Hair & Glo Skin Clinics are now positioned as high-performing
                                    brands in India’s aesthetic healthcare sector
                                </p>

                                <h3 className="case-study-title mb-4">Powering Growth Across 6 Cities with Digital Precesion</h3>
                                <Row>
                                    <Col md={3}>
                                        <img src={map} alt="logo" className="map mb-3" />
                                    </Col>
                                    <Col md={9}>
                                        <h4 className="case-study-title">Tamil Nadu</h4>

                                        <div className="title-pill mb-4 d-inline-block me-2">Kottivakkam, Chennai</div>
                                        <div className="title-pill mb-4 d-inline-block me-2">Vellore </div>
                                        <div className="title-pill mb-4 d-inline-block me-2">Erode</div>

                                        <h4 className="case-study-title">Karnataka</h4>

                                        <div className="title-pill mb-4 d-inline-block">Mangalore</div>

                                        <h4 className="case-study-title">Kerala</h4>

                                        <div className="title-pill mb-4 d-inline-block me-2">Trivandrum  </div>
                                        <div className="title-pill mb-4 d-inline-block me-2">Thrissur</div>

                                    </Col>
                                </Row>

                                <h3 className="case-study-title mb-4">Impact Snapshot</h3>
                                
                                <Table className="case-study-table" >
                                    <thead>
                                        <tr>
                                            <th>Metric</th>
                                            <th>Before</th>
                                            <th>After</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr> 
                                            <td>Leads/ Month</td>
                                            <td>120</td>    
                                            <td>480+</td>
                                        </tr>
                                         <tr> 
                                            <td>Cost/ Lead</td>
                                            <td>RS. 290</td>    
                                            <td>Rs. 95</td>
                                        </tr>
                                         <tr> 
                                            <td>Booking Rate</td>
                                            <td>18%</td>    
                                            <td>42%</td>
                                        </tr>
                                         <tr> 
                                            <td>AD ROI</td>
                                            <td>1.5x</td>    
                                            <td>5x</td>
                                        </tr>
                                         <tr> 
                                            <td>Website Traffic</td>
                                            <td>+25%</td>    
                                            <td>+220%</td>
                                        </tr>
                                    </tbody>
                                </Table>

                                 <h3 className="case-study-title">Why it Works</h3>

                                <ul>
                                    <li>Hyperlocal Approach</li>
                                    <li>Deep Audience Insights</li>
                                    <li>Smart Creative Testing</li>
                                    <li>Tight Coordination with Clinic Teams</li>
                                </ul>


                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="position-relative">
                <img src={rover} alt='floating-icons' className='floating-icons left' />
                <img src={dna} alt='floating-icons' className='floating-icons right bottom' />



                <Container className="pb-5 mb-5" ref={el => sectionRefs.current[5] = el} data-idx={5}>
                    <Row>
                        <Col xs={{ span: 12, order: 'last' }} lg={{ span: 9, order: 'first' }} className={`case-study-wrapper${expandedSections.includes(5) ? ' expanded' : ''}`}>
                            <div className="case-study-card">
                                <h2 className="case-study-title">Fillr By DR. F</h2>
                                <p className="case-study-description">
                                    FILLR BY DR. F, is a premium aesthetic and skincare clinic
                                    in Adyar, Chennai, specializing in injectables and advanced
                                    facial treatments. They partnered with Ad Rocket to boost
                                    online visibility, attract high-intent clients, and increase
                                    ROI through precesion-driven digital marketing
                                </p>

                                <h3 className="case-study-title">Challenges</h3>

                                <ul>
                                    <li>Low online visibility despite a strong local reputation</li>
                                    <li>Inconsistent lead quality from paid campaigns</li>
                                    <li>Limited engagement on social media</li>
                                    <li>Need for measurable ROI and brand differentiation</li>
                                </ul>

                                <h3 className="case-study-title">Results</h3>


                                <p className="case-study-description">Through targeted Meta and Google Ads, content
                                    optimazation, and testimonial-based creatives,
                                    Fillr achieved a 3.2x increase in qualified leads,
                                    45% higher enagagement, and a 28% improvement
                                    in ROI, establishing itself as one of Adyar’s most
                                    sought-after aesthetic clinics
                                </p>


                            </div>
                        </Col>
                        <Col xs={{ span: 12, order: 'first' }} lg={{ span: 3, order: 'last' }} className="mx-auto">
                            <div className={`logo-circle me-auto${expandedSections.includes(5) ? ' expanded' : ''}`}>
                                <img src={filler_logo} alt="logo" className="case-study-logo" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="position-relative">
                <img src={gallaxy} alt='floating-icons' className='floating-icons left' />
                <img src={sun} alt='floating-icons' className='floating-icons right bottom' />


                <Container className="pb-5 mb-5 mt-3" ref={el => sectionRefs.current[6] = el} data-idx={6}>
                    <Row>
                        <Col xs={12} lg={3} className="mx-auto">
                            <div className={`logo-circle ms-lg-auto${expandedSections.includes(6) ? ' expanded' : ''}`}>
                                <img src={mahive_logo} alt="logo" className="case-study-logo" />
                            </div>
                        </Col>
                        <Col xs={12} lg={9} className={`case-study-wrapper${expandedSections.includes(6) ? ' expanded' : ''}`}>
                            <div className="case-study-card">
                                <h2 className="case-study-title">mahive engineering solutions</h2>
                                <p className="case-study-description">
                                    MAHIVE ENGINEERING SOLUTIONS, is a Maryland-based
                                    engineering and 3D laser scanning company, partnered
                                    with Ad Rocket to enhance its digital visibility and attract
                                    high-value industrial clients across the U.S. through a
                                    strategic digital marketing approach
                                </p>

                                <h3 className="case-study-title">Challenges</h3>

                                <ul>
                                    <li>Low online visibility in a competitive B2B space</li>
                                    <li>Limited inbound inquiries from target industries</li>
                                    <li>Underperforming ad campaigns with unclear ROI</li>
                                    <li>Need for stronger brand authority and credibili</li>
                                </ul>

                                <h3 className="case-study-title">Results</h3>

                                <p className="case-study-description">With optimised Google Ads, SEO-driven content, and LinkedIn campaigns,
                                    Mahive achieved a 2.8x increase in qualified leads, a 60% boost in website
                                    traffic, and a 40% improvement in ROI, establishing a strong digital
                                    footprint in the U.S. engineering market
                                </p>


                            </div>
                        </Col>
                    </Row>
                </Container>

            </div>

            <div className="position-relative">
                <img src={moon} alt='floating-icons' className='floating-icons left' />
                <img src={rocketIcon} alt='floating-icons' className='floating-icons right bottom' />


                <Container className="pb-5 mb-5" ref={el => sectionRefs.current[7] = el} data-idx={7}>
                    <Row>
                        <Col xs={{ span: 12, order: 'last' }} lg={{ span: 9, order: 'first' }} className={`case-study-wrapper${expandedSections.includes(7) ? ' expanded' : ''}`}>
                            <div className="case-study-card">
                                <h2 className="case-study-title">sathish design studio</h2>
                                <p className="case-study-description">
                                    SATHISH DESIGN STUDIO, a Chennai-based interior and
                                    architectural firm, partnered with Ad Rocket to enhance
                                    its digital presence, attract premium clients, and generate
                                    consistent, high-quality leads through Meta and Google
                                    Ads
                                </p>

                                <h3 className="case-study-title">Challenges</h3>

                                <ul>
                                    <li>Low Online Visibility despite a strong portfolio</li>
                                    <li>Unqualified leads from generic campaigns</li>
                                    <li>Limited engagement across digital platforms</li>
                                    <li>Difficulty tracking ROI and Conversions</li>
                                </ul>

                                <h3 className="case-study-title">Results</h3>


                                <p className="case-study-description">With a data-driven ad strategy and visually rich creatives, Sathish Design
                                    Studio experienced a 4x increase in qualified leads, a 60% boost in website
                                    traffic, and a 40% higher ROI. Enhanced visibility and targeted campaigns
                                    positioned the brand as a go-to name for bespoke interiors in Chennai.

                                </p>


                            </div>
                        </Col>
                        <Col xs={{ span: 12, order: 'first' }} lg={{ span: 3, order: 'last' }} className="mx-auto">
                            <div className={`logo-circle me-auto${expandedSections.includes(7) ? ' expanded' : ''}`}>
                                <img src={sathish_logo} alt="logo" className="case-study-logo" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>



        </div>
    )
};

export default CaseStudy;